/* eslint-disable react/prop-types */
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { truncateString, ActionsCellRenderer } from "utils/helpers";
import DeleteIcon from "assets/images/icons/deleteIcon.svg";
import EditIcon from "assets/images/icons/editIcon.svg";
import { visibilityOptions } from "../../../../constants";
import StatusChip from "components/common/StatusChip";

export const makeColumns = (handleAction, handleUpdateStatus) => {
  const columns = [
    {
      Header: "Title",
      accessor: "title",
      width: "25%",
      align: "left",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
            {truncateString(value, 25)}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Traffic",
      accessor: "stats.traffic",
      width: "10%",
      Cell: ({ value }) => {
        return (
          <MDBox>
            <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
              {value ? value : "-"}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      Header: "Website",
      accessor: "url",
      width: "20%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "500" }}>
            {truncateString(value, 30)}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Link Type",
      accessor: "linkType",
      width: "15%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
            {value === "DO_FOLLOW" ? "Do Follow" : "No Follow"}
          </MDTypography>
        </MDBox>
      ),
    },

    {
      Header: "Credits",
      accessor: "price",
      width: "10%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
            <strong>{value}</strong>
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Visibility",
      width: "12%",
      accessor: "visibility",
      Cell: ({ value, row }) => (
        <StatusChip
          value={value}
          options={visibilityOptions}
          onChange={(val) => handleUpdateStatus(row, val)}
        />
      ),
    },
    {
      Header: "Action",
      align: "right",
      width: "15%",
      Cell: ({ row }) => (
        <ActionsCellRenderer
          actions={[
            { imgIcon: EditIcon, onClick: () => handleAction(row.original.id, "edit") },
            { imgIcon: DeleteIcon, onClick: () => handleAction(row.original.id, "delete") },
          ]}
        />
      ),
    },
  ];

  return columns;
};
